import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Button } from '@mui/material';
import { RefreshIcon, CloseIcon } from 'components/elements/Icons';
import { VideoCallSettings, VideoSessionAccessContacts, VideoSessionInstructions } from 'components/modules';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoSessionSettingsModal({ videoSessionId, twilioSessionToken, data, onRefresh, onApply, onClose }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <div className={classes.videoSettings}>
      <div>
        <button
          className={classes.closeButton}
          type="button"
          onClick={() => {
            onApply();
            onClose();
          }}
        >
          <CloseIcon />
        </button>
        <Typography className={classes.roomHeader} variant="h5" component="h5">
          {t('video_session_settings')}
        </Typography>
      </div>
      <div className={classes.videoSettingsScrollWrap}>
        <VideoCallSettings
          sessionName={data.sessionName}
          accountName={data.accountDisplayName}
          sessionToken={data.adracareSessionToken}
          roomName={videoSessionId}
          token={twilioSessionToken}
        />
        <Button
          className={classes.controlButton}
          type="submit"
          variant="contained"
          size="large"
          onClick={() => {
            onRefresh();
            onClose();
          }}
        >
          <RefreshIcon classes={classes.refreshButtonIcon} />
          <Typography className={classes.controlButtonText} variant="span" component="span">
            {t('refresh_connection')}
          </Typography>
        </Button>
        <VideoSessionInstructions />
        <VideoSessionAccessContacts sessionDetails={data || []} />
      </div>
    </div>
  );
}

VideoSessionSettingsModal.propTypes = {
  twilioSessionToken: PropTypes.string.isRequired,
  videoSessionId: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onRefresh: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default VideoSessionSettingsModal;
